document.querySelectorAll('[data-bf-hero]').forEach((section) => {
  const targetDate = Date.parse(section.dataset.countdownDate);

  const days = section.querySelector('[data-bf-days]');
  const hours = section.querySelector('[data-bf-hours]');
  const minutes = section.querySelector('[data-bf-minutes]');
  const seconds = section.querySelector('[data-bf-seconds]');

  if (!Number.isFinite(targetDate) || !days || !hours || !minutes || !seconds) return;

  const pad = (value) => String(value).padStart(2, '0');

  const updateCountdown = () => {
    const remaining = Math.max(0, Math.floor((targetDate - Date.now()) / 1000));

    days.textContent = pad(Math.floor(remaining / 86400));
    hours.textContent = pad(Math.floor((remaining % 86400) / 3600));
    minutes.textContent = pad(Math.floor((remaining % 3600) / 60));
    seconds.textContent = pad(remaining % 60);

    if (remaining === 0) {
      clearInterval(interval);
    }
  };

  updateCountdown();

  const interval = targetDate > Date.now()
    ? setInterval(updateCountdown, 1000)
    : null;
});

let leadSent = false;

window.addEventListener('klaviyoForms', (event) => {
  const detail = event.detail;

  if (
    detail?.type !== 'submit' ||
    detail?.formId !== 'UNyhHY' ||
    leadSent
  ) return;

  if (typeof window.fbq === 'function') {
    window.fbq('track', 'Lead', {
      content_name: 'Glytone Black Friday Early Access',
      source: 'Klaviyo'
    });

    leadSent = true;
  }
});